import React from 'react'
import { CoverActivationTarget, CoverRoot } from './FocusableCover.styles'

type FocusableCoverProps = {
  title?: string | null
  onClickBook?: () => void
  className?: string
  a11yEnabled?: boolean
  children: React.ReactNode
}

const FocusableCover: React.FC<FocusableCoverProps> = ({
  title,
  onClickBook,
  className,
  a11yEnabled,
  children
}) => (
  <CoverRoot className={className} $a11yEnabled={a11yEnabled}>
    {onClickBook && title && (
      <CoverActivationTarget
        type="button"
        aria-label={title}
        onClick={onClickBook}
      />
    )}
    {children}
  </CoverRoot>
)

export default FocusableCover
